import PropTypes from 'prop-types'

import breakpoints from './breakpoints'
import heights from './heights'
import palette from './palette'
import radii from './radii'
import shadows from './shadows'
import space from './spacing'
import { fontSizes, fontWeights, lineHeights } from './typography'

const primaryTheme = {
  name: 'Light',
  colors: palette,
  breakpoints,
  radii,
  space,
  fontSizes,
  fontWeights,
  lineHeights,
  sizes: space,
  shadows,
  heights,
}

export const sizePropsTypes = PropTypes.oneOfType([
  PropTypes.arrayOf(
    PropTypes.oneOf(['xs', 'sm', 'md', 'md2', 'lg', 'xl', 'xxl']),
  ),
  PropTypes.oneOf(['xs', 'sm', 'md', 'md2', 'lg', 'xl', 'xxl']),
])

export default primaryTheme
